// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--1oOSF","list":"index-module--list--1oP4b","item":"index-module--item--1gZGM"};